module.exports = __webpack_public_path__ + "img/refunded_status.47493448.png";